/* ============================================================
   FLAMINGOS LIFE — Zero Grit · Coming Soon
   Sin dependencias (el tema sirve jQuery, GSAP y ScrollMagic, pero
   para esto no hacen falta).

   1. .zg-tech — indice de rasgos con foto fija, en escritorio.
      Cada rasgo ocupa una pantalla (el alto del escenario) con el texto
      centrado. EL RASGO ACTIVO ES EL QUE CRUZA EL CENTRO DE LA VENTANA:
      el ultimo cuyo borde superior ha pasado ya el 50 % (antes, el
      primero). Se calcula EN CADA SCROLL a partir de la posicion real,
      no con eventos de entrada y salida.

      Por que: la v1 usaba un IntersectionObserver con una franja del
      10 % en el centro de la ventana, y fallaba en 30 de 156
      posiciones del test (scripts/test-indice-rasgos.js) por dos
      razones:
        - con un scroll rapido un rasgo puede saltarse la franja sin
          que el observador lo vea, y la foto se quedaba en el anterior;
        - el estado solo cambiaba al entrar un rasgo en la franja:
          llegando al bloque desde abajo, o subiendo hasta el principio,
          seguia activa la foto del ultimo rasgo que la cruzo.
      Calcular desde la posicion no depende de la historia del scroll.

      v1.2: con rasgos de 28vh y la linea al 60 %, el siguiente rasgo se
      activaba antes de que el escenario terminara de entrar en pantalla,
      y el video del 01 no se veia nunca entero con el 01 activo.

      Pulsar un rasgo lo alinea con el escenario; durante el
      desplazamiento suave el calculo va pasando por los intermedios y
      acaba en el pulsado.

   2. Videos. Solo se reproduce el del rasgo activo en el escenario; en
      movil, cada video mientras esta en pantalla. El del hero elige su
      fuente por ancho (apaisado en escritorio, vertical en movil) y se
      pausa fuera de la vista. Con «reducir
      movimiento» no se reproduce ninguno y se queda el poster, que es
      el fotograma que ensena el rasgo.

   Se puede cargar varias veces (el personalizador re-renderiza
   secciones): cada bloque se marca con data-zg-ready.
   ============================================================ */
(function () {
  'use strict';

  // Cada seccion de la landing carga este fichero (un CSS + un JS por
  // seccion, como el resto del tema): solo se ejecuta la primera vez.
  if (window.zgLanding) return;
  window.zgLanding = true;

  var desktop = window.matchMedia('(min-width: 900px)');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var LINEA = 0.5;

  function reproducir(v) {
    if (!v || reduced.matches) return;
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  function initTech(root) {
    if (root.dataset.zgReady) return;
    root.dataset.zgReady = '1';

    var items = Array.prototype.slice.call(root.querySelectorAll('.zg-feature'));
    var frames = Array.prototype.slice.call(root.querySelectorAll('.zg-tech__frame'));
    var stage = root.querySelector('.zg-tech__stage');
    if (!items.length || items.length !== frames.length) return;

    var activo = -1;

    function activar(i) {
      if (i === activo) return;
      activo = i;
      items.forEach(function (it, k) { it.classList.toggle('is-active', k === i); });
      frames.forEach(function (fr, k) {
        fr.classList.toggle('is-active', k === i);
        var v = fr.querySelector('video');
        if (!v) return;
        if (k === i && desktop.matches) { v.currentTime = 0; reproducir(v); }
        else v.pause();
      });
    }

    function calcular() {
      if (!desktop.matches) return;
      var linea = window.innerHeight * LINEA;
      var k = 0;
      for (var i = 0; i < items.length; i++) {
        if (items[i].getBoundingClientRect().top <= linea) k = i;
        else break;
      }
      activar(k);
    }

    var pendiente = false;
    function alScroll() {
      if (pendiente) return;
      pendiente = true;
      window.requestAnimationFrame(function () { pendiente = false; calcular(); });
    }

    window.addEventListener('scroll', alScroll, { passive: true });
    window.addEventListener('resize', alScroll);
    desktop.addEventListener('change', function () { activo = -1; calcular(); });

    items.forEach(function (it, i) {
      it.addEventListener('click', function () {
        if (!desktop.matches) return;
        // Alinea el rasgo con el escenario pegado: su texto queda centrado
        // junto a la foto.
        var arriba = stage ? parseFloat(window.getComputedStyle(stage).top) || 0 : 0;
        var y = items[i].getBoundingClientRect().top + window.scrollY - arriba;
        window.scrollTo({ top: y, behavior: reduced.matches ? 'auto' : 'smooth' });
      });
    });

    activar(0);
    calcular();
  }

  // Videos de los rasgos en movil: suenan solo mientras se ven.
  function initVideosMovil(scope) {
    var vids = (scope || document).querySelectorAll('.zg-feature__media video');
    if (!vids.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting && !desktop.matches) reproducir(e.target);
        else e.target.pause();
      });
    }, { threshold: 0.3 });
    vids.forEach(function (v) {
      if (v.dataset.zgReady) return;
      v.dataset.zgReady = '1';
      io.observe(v);
    });
  }

  // Hero de video. La fuente se elige por ancho (data-src-escritorio /
  // data-src-movil, con su poster) y solo se descarga esa: el <video> llega
  // sin src y con preload="none". Se pausa cuando el hero sale de la vista.
  function initHero(el) {
    if (el.dataset.zgReady) return;
    el.dataset.zgReady = '1';
    var v = el.querySelector('video');
    if (!v) return;
    var visible = true;

    // .is-ancho cuando la ventana es mas apaisada que el video: entonces se ve
    // entero y no recortado (ver la hoja).
    function encaje() {
      var r = el.getBoundingClientRect();
      var prop = v.videoWidth && v.videoHeight ? v.videoWidth / v.videoHeight : 16 / 9;
      el.classList.toggle('is-ancho', desktop.matches && r.height > 0 && r.width / r.height > prop);
    }

    function elegir() {
      var movil = !desktop.matches && v.dataset.srcMovil;
      var src = movil ? v.dataset.srcMovil : v.dataset.srcEscritorio;
      var poster = movil ? v.dataset.posterMovil : v.dataset.posterEscritorio;
      if (src && v.getAttribute('src') !== src) {
        if (poster) v.poster = poster;
        v.preload = 'auto';
        v.src = src;
      }
      if (visible) reproducir(v); else v.pause();
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (visible) reproducir(v); else v.pause();
      }, { threshold: 0.1 }).observe(el);
    }
    desktop.addEventListener('change', function () { elegir(); encaje(); });
    window.addEventListener('resize', encaje);
    v.addEventListener('loadedmetadata', encaje);
    elegir();
    encaje();
  }

  function init(scope) {
    (scope || document).querySelectorAll('.zg-hero--video').forEach(initHero);
    (scope || document).querySelectorAll('.zg-tech').forEach(initTech);
    initVideosMovil(scope);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  // Personalizador de Shopify: al recargar una seccion, se reinicia solo esa.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
